var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex align-items-center",on:{"click":_vm.minimizeAndViewProfile}},[_c('img',{staticClass:"img-fluid rounded-circle",attrs:{"src":_vm.standardMap.primaryPhoto.small}})])
}
var staticRenderFns = []

export { render, staticRenderFns }